import React, { useState, useCallback } from 'react'
import PropTypes from 'helpers/proptypes'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import { useEmailValidation } from 'hooks/accounts/useEmailValidation'
import * as Yup from 'yup'
import { Modal, Icon, Form } from 'semantic-ui-react'
import ApiErrorMessage from 'components/errors/ApiErrorMessage'
import { toast } from 'react-toastify'

function EditEmailForm({ accountId, email, onUpdate }){
  const { t } = useTranslation() 

  const formik = useFormik({
    initialValues: {
      old_email: email,
      new_email: ''
    },
    validationSchema: Yup.object().shape({
      old_email: Yup.string().required(),
      new_email: Yup.string().required(),
    }),
    onSubmit: () => validateAccount(),
  })

  const onValidation = useCallback(() => {
    onUpdate()
    toast.success(`${t("ToastNotification::User's email has been updated and the account has been validated")} 👍`, { type: toast.TYPE.SUCCESS })
  }, [t])

  const { 
    isValidating, 
    validateError, 
    validateAccount 
  } = useEmailValidation({ 
    accountId, 
    onValidation, 
    oldEmail: formik.values.old_email, 
    newEmail: formik.values.new_email 
  })

  return (
    <>
      <Form onSubmit={formik.handleSubmit}>
        <Form.Input name='old_email' label={t('EditEmailForm::Current Email')} type='email' value={formik.values.old_email} error={formik.touched.old_email && formik.errors.old_email && t(formik.errors.old_email)} onChange={formik.handleChange} />
        <Form.Input name='new_email' label={t('EditEmailForm::New Email')} type='email' value={formik.values.new_email} error={formik.touched.new_email && formik.errors.new_email && t(formik.errors.new_email)} onChange={formik.handleChange} />
        <div style={{ display: 'flex', justifyContent:'flex-end' }}>
          <Form.Button type='submit' primary disabled={isValidating}>
            {t('EditEmailForm::Update')}
          </Form.Button>
        </div>
      </Form>
      <ApiErrorMessage error={validateError} noStack />
    </>
  )
}

EditEmailForm.propTypes = {
  accountId: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
}

export function EditEmailPopupForm({ account }){
  const { t } = useTranslation()
  const [isOpen, setIsopen]=useState(false)

  function handleClose(){
    setIsopen(false)
  }

  return (<Modal
    trigger={<Icon name='edit' size='large' color='grey' style={{ cursor: 'pointer' }} />}
    on='click'
    open={isOpen}
    onClose={handleClose}
    onOpen={()=>setIsopen(true)}
    >
      <Modal.Header>{t('EditEmailForm::Update user email')}</Modal.Header>
      <Modal.Content>
        <EditEmailForm accountId={account.id} email={account.email} onUpdate={handleClose} />
      </Modal.Content>
    </Modal>)
}

EditEmailPopupForm.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
  }).isRequired,
}